// extracted by mini-css-extract-plugin
export var Close = "Search-module--Close--47d32";
export var Search = "Search-module--Search--2b9fd";
export var Wrapper = "Search-module--Wrapper--1438e";